import { render, staticRenderFns } from "./AgentEmailDDL.vue?vue&type=template&id=2707e3ff"
import script from "./AgentEmailDDL.vue?vue&type=script&lang=js"
export * from "./AgentEmailDDL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports